import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUsersMe } from '../../../../api/user/queries/getUsersMe';
import { IUser } from '../../../../interfaces/User.interfaces';
import { userProfileSlice } from '../../../../store/userProfileSlice';
import { useAppDispatch } from '../../../store/useStore';
import { useCheckUserLoggedIn } from '../../../user/useCheckUserLoggedIn';

export const useGetUsersMeQuery = () => {
  const dispatch = useAppDispatch();
  const userProfileActions = userProfileSlice.actions;
  const navigate = useNavigate();

  const { isUserLoggedIn } = useCheckUserLoggedIn();

  const query = useQuery<IUser, AxiosError>(['users_me'], getUsersMe, {
    enabled: isUserLoggedIn,
  });

  useEffect(() => {
    if (query.error) {
      if (query.error.response?.status === 401) {
        navigate('/logout');
      }
    } else if (query.data && query.data !== undefined) {
      dispatch(userProfileActions.setUserProfile(query.data));
    }
  }, [dispatch, userProfileActions, query.data, query.error, navigate]);

  return query;
};
